import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import styled from 'styled-components'
import { getCurrentServerUrl } from '../../helpers/axios'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin: 15px 0 15px 0;
  padding: 0 18px 20px 18px;
  border-bottom: 1px solid #ececf0;

  word-wrap: break-word;
`

const StyledTicketInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #2e384d;

  .number {
    font-size: 13px;
  }
`

const StyledAuthorInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 8px;

  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #b0bac9;
  letter-spacing: 1.12px;

  .date {
    font-size: 10px;
    color: #8097b1;
    letter-spacing: 2.2px;
  }
`

const StyledMessageInfo = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
`

const StyledFileList = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin-top: 20px;
`

const StyledFileItem = styled.a`
  display: flex;
  align-items: center;
  color: #8b93a7;
  margin-right: 15px;

  .iconContainer {
    margin-right: 10px;
  }

  .file_name {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    font-size: 13px;
  }
`

class InfoBar extends Component {
  render() {
    const {
      data,
      message = {
        attachments: []
      }
    } = this.props
    const { subject, number } = data

    const { author, date, text, attachments } = message

    return (
      <Wrapper>
        <StyledTicketInfo>
          <div>{subject}</div>
          <div className="number">{number}</div>
        </StyledTicketInfo>
        <StyledAuthorInfo>
          <div>{author}</div>
          <div className="date">{moment(date).format('DD/MM/YY - HH:mm')}</div>
        </StyledAuthorInfo>
        <StyledMessageInfo dangerouslySetInnerHTML={{ __html: text }} />
        {attachments.length > 0 && (
          <StyledFileList>
            {attachments.map(({ url, thumbnail, name }) => {
              return (
                <StyledFileItem
                  href={getFileHREF(url)}
                  download={name}
                  target="_blank"
                  thumbUrl={thumbnail}
                  title={name}
                  key={url}
                >
                  <div className="iconContainer">
                    <FontAwesomeIcon size="1x" icon="file-download" />
                  </div>
                  <div className="file_name">{name}</div>
                </StyledFileItem>
              )
            })}
          </StyledFileList>
        )}
      </Wrapper>
    )
  }
}

export default InfoBar

const getFileHREF = (url) => {
  if (!url) return ''
  if (url.startsWith('http')) {
    return url
  }

  return `${getCurrentServerUrl()}${url}`
}
